export default [
  { name: 'all', text: 'Все' },
  {
    name: 'navigation',
    text: 'Навигация',
  },
  {
    name: 'heading',
    text: 'Заголовки',
  },
  {
    name: 'html',
    text: 'Текст',
  },
  {
    name: 'advantages',
    text: 'Преимущества',
  },
  {
    name: 'gallery',
    text: 'Галерея',
  },

  {
    name: 'delimeter',
    text: 'Разделитель',
  },
  {
    name: 'table',
    text: 'Таблицы',
  },
  {
    name: 'columns',
    text: 'Колонки',
  },
  {
    name: 'lists',
    text: 'Списки',
  },
];
